export function getReturnTo({
  pathname = '',
  search = '',
}: {
  pathname?: string | null;
  search?: string;
}) {
  let returnTo = '/login';
  if (pathname && pathname.length > 1 && !pathname.includes('action')) {
    returnTo += `?return_to=${pathname}${search}`;
  }

  return returnTo;
}

export function getReturnToUrl(request: Request) {
  const url = new URL(request.url);
  const returnTo = getReturnTo(url);

  return returnTo;
}
